import * as React from "react";
import { useAccess } from "./duck/hooks";
import { NoAccess } from "../errors";

interface AccessRouteProps {
  children: React.ReactNode;
  path: string;
}

const AccessRoute: React.FC<AccessRouteProps> = ({ children, path }) => {
  const failedLicense = useAccess(path);

  return failedLicense ? <NoAccess failedLicense={failedLicense} /> : children;
};

export default AccessRoute;
